// React
import { createContext } from "react";

export const mainContext = createContext({});